import React from "react";

export default function SingleFinder() {
  return <div>Index</div>;
}
